// Mock data for development when AWS services are not available

export const mockUnits = [
  {
    project_id: "Aria",
    building_id: "1",
    unit_number: "101",
    region: "Arizona",
    state: "AZ",
    plan_type: "Plan A",
    plan_sf: 1200,
    bedrooms: 2,
    bathrooms: 2,
    sales_status: {
      status_key: "inventory",
      status_label: "Available",
      status_color: "#31a354",
      status_date: "2024-01-01"
    }
  },
  {
    project_id: "Aria", 
    building_id: "1",
    unit_number: "102",
    region: "Arizona",
    state: "AZ",
    plan_type: "Plan B",
    plan_sf: 1400,
    bedrooms: 3,
    bathrooms: 2,
    sales_status: {
      status_key: "backlog",
      status_label: "Ratified",
      status_color: "#fdae6b",
      status_date: "2024-02-01"
    }
  },
  {
    project_id: "Fusion",
    building_id: "2", 
    unit_number: "201",
    region: "Arizona",
    state: "AZ",
    plan_type: "Plan C",
    plan_sf: 1600,
    bedrooms: 3,
    bathrooms: 3,
    sales_status: {
      status_key: "closed",
      status_label: "Closed",
      status_color: "#e34a33",
      status_date: "2024-03-15"
    }
  },
  {
    project_id: "SoMi A",
    building_id: "A",
    unit_number: "A101",
    region: "Florida",
    state: "FL",
    plan_type: "Plan D",
    plan_sf: 1350,
    bedrooms: 3,
    bathrooms: 2.5,
    sales_status: {
      status_key: "inventory",
      status_label: "Available",
      status_color: "#31a354",
      status_date: "2024-01-15"
    }
  }
];

export const mockHolidays = [
  { project_id: "Aria", date: "2024-12-25" },
  { project_id: "Aria", date: "2024-01-01" },
  { project_id: "Fusion", date: "2024-12-25" },
  { project_id: "Fusion", date: "2024-01-01" }
];

export const mockMilestones = {};

export const mockSalesStatus = {};
